import TransfersList from "./styles";

export default TransfersList;
